import QuizTypes from 'types/QuizTypes';
import QuestionTypes from 'types/QuestionTypes';
import IQuiz from 'models/Quiz';
import IQuestion from 'models/Question';

const LONG_TIMEOUT_QUESTION_TYPES = [
  QuestionTypes.ConnectionGrid,
  QuestionTypes.ImagePin,
  QuestionTypes.TopList,
];

export const getQuestionDefaultTimeout = (quizType: QuizTypes, questionType: QuestionTypes): number => {
  return quizType === QuizTypes.Prediction || LONG_TIMEOUT_QUESTION_TYPES.includes(questionType) ? 30 : 10;
};

export const getQuestionTimeout = (quiz: IQuiz, question: IQuestion): number => {
  return question.timeout || getQuestionDefaultTimeout(quiz.type, question.type);
};

export const getQuestionMaxScore = (quiz: IQuiz, question: IQuestion): number => {
  return question.score || (getQuestionTimeout(quiz, question) * 100);
};
